<template>
  <div class="metrics" :role="divRole" aria-labelledby="sectionTitle">
    <template v-for="metric of metrics">
      <!-- Skeleton -->
      <template v-if="sessionsMetricsReport.loading">
        <div :key="'div-' + metric.title" class="metric">
          <span>{{ metric.title }}</span>
          <skeleton width="30px" height="26px" />
        </div>
      </template>

      <!-- Not Clickable -->
      <!-- <template v-else-if="!metricIsClickable(metric)">
        <div :key="'div-' + metric.title" class="metric no-action">
          <span>{{ metric.title }}</span>
          <strong>{{ metric.metric }}</strong>
        </div>
      </template> -->

      <template v-else>
        <div :key="'div-' + metric.title" class="metric no-action">
          <span>{{ metric.title }}</span>
          <strong>{{ metric.metric }}</strong>
        </div>
      </template>

      <!-- Clickable -->
      <!-- <template v-else>
        <input
          :key="'input-' + metric.title"
          type="radio"
          name="status"
          :value="metric.title"
          :checked="filtered === metric.filter"
          :aria-checked="filtered === metric.filter ? 'true' : 'false'"
          @click="$emit('filter', metric.filter)"
        />
        <div
          :key="'div-' + metric.title"
          :class="metric"
          @click="!disabled && $emit('filter', metric.filter)"
        >
          <span>{{ metric.title }}</span>
          <strong>{{ metric.metric }}</strong>
        </div>
      </template> -->
    </template>
  </div>
</template>

<script>
import Skeleton from '../../../Skeleton.vue';

export default {
  name: 'Metrics',
  components: {
    Skeleton
  },

  props: {
    timeframe: {
      type: String,
      required: false,
      default: 'recent'
    },
    filtered: {
      type: String,
      required: false,
      default: 'all'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  inject: ['sessionsMetricsReport'],

  computed: {
    metrics() {
      const data = this.sessionsMetricsReport.data;
      if (this.timeframe === 'upcoming') {
        return [
          { title: 'Approved', metric: this.calcApproved(data) }
        ];
      }
      return [
        { 
          title: 'All', 
          filter: 'all', 
          metric: this.calcAll(data) 
        },
        {
          title: 'Successful',
          filter: 'successful',
          metric: this.calcSuccessful(data)
        },
        {
          title: 'Canceled',
          filter: 'canceled',
          metric: this.calcCanceled(data)
        },
        {
          title: 'Not Attended',
          filter: 'not attended',
          metric: this.calcNotAttended(data)
        }
      ];
    },

    divRole() {
      if (this.metrics.some((x) => !!x.filter && x.metric > 0)) {
        return 'radiogroup';
      }
      return '';
    }
  },

  methods: {
    metricIsClickable(metric) {
      return !!metric.filter && metric.metric > 0;
    },

    calcRequested(data) {
      if (!data || !data.requests) return 0;

      return data.requests.pending;
    },
    calcApproved(data) {
      if (!data || !data.requests) return 0;

      return data.requests.approved + data.requests.inProgress;
    },
    calcAll(data) {
      if (!data) return 0;

      let count = 0;
      for (const val of Object.values(data.attended || {})) count += val;
      for (const val of Object.values(data.canceled || {})) count += val;

      return count;
    },
    calcSuccessful(data) {
      if (!data || !data.attended) return 0;

      return data.attended.both;
    },
    calcCanceled(data) {
      if (!data || !data.canceled) return 0;

      return (
        data.canceled.byStudent +
        data.canceled.byStudentWithin24Hours +
        data.canceled.byCounselor +
        data.canceled.byCounselorWithin24Hours +
        data.canceled.byAdmin
      );
    },
    calcNotAttended(data) {
      if (!data || !data.attended) return 0;

      return (
        data.attended.onlyStudent +
        data.attended.onlyCounselor +
        data.attended.neither
      );
    }
  }
};
</script>
